import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import GrundfosContent from "./GrundfosPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/grundfos/pumps" component={GrundfosContent} />
          <Route path="/suppliers/grundfos">
            <Redirect to="/suppliers/grundfos/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
